import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class IndustrialDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  <h4>Industrial School (Recognised by the Govt of TamilNadu):</h4>
				  <p><i>Are you strong enough to withstand any industrial work?</i> MIET’s group of experienced tutors nourishes you to be Industry-ready with all theory and practical knowledge needed. </p>
				  <p>Industrial School Training Programme is introduced to craft the youth to numerous employment opportunities in 90 trades. Candidates with 8th and 10th pass qualifications are eligible to be admitted for training in various trades. </p>
		          <p>The Industry courses offered by <b>MIET</b> are well-structured and well-equipped with advanced facilities that get you the hands-on experience required by various trades. </p>
				 
                  </ScrollAnimation>
                  <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							<p><b>Admissions: [March - September]</b></p>
							<p><b>Eligibility: </b></p>
							<ul>
								<li>8th pass</li>
								<li>Age: 14-40 years</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>
				  
					<ScrollAnimation animateIn="fadeInRight">
					<table>
						<tr>
							<th>Trade name</th>
							<th>Duration</th>
						</tr>
						<tr>
							<td>Automobile Mechanic</td>
							<td>1 Years</td>
						</tr>
						<tr>
							<td>Electrical & Electronics Technician	</td>
							<td>2 Years</td>
						</tr>
						<tr>
							<td>Refrigeration & A/C Mechanism & Maintenance</td>
							<td>2 Years</td>
						</tr>
						<tr>
							<td>Electrical Technician</td>
							<td>1 Years</td>
						</tr>
					</table>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							<h5 className="mb-0 mt-2">Syllabus:</h5><br/>
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Professional skill / Trade Practical
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />  Professional knowledge / Trade theory
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Workshop Science & calculation
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />  Engineering drawing
								</li>
                                {/* <b>Not just theory, we help you gain practical skills too!</b> */}
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
						<h5 className="mb-0 mt-2">Earn while you Learn:</h5><br/>
						<p><b>MIET</b> offers its students <b>Internship</b> programs to learn new skills and improve their employability value. Students can gain knowledge and confidence working in companies while studying and also gain monetary support. <b>Students get Financial aid while earning and could support their family.</b></p>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Application Form:</h5><br/>
						<Link to="/online-payment"><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></Link>
					</blockquote>
					</div>
					</ScrollAnimation>
				  </div>
		      </div>
			  <Sidebar courseRestriction="Industrial School" />
		    </div>
		  </div>
		</div>

        }
}

export default IndustrialDetails